import React, { Component } from 'react';
import SFavouritesInformation from 'shared/screens/FavouritesInformation';
import CopySelector from 'shared/utils/copySelector';
import LevelUpText from './components/LevelUpText';

const headerBackground = require(asset`Full_Modal_Header@3x.png`);
export default class FavouritesInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  static get AsModalProps() {
    return {
      dialogClassName: 'gtp-modal-favourites-information',
    };
  }

  render() {
    return (
      <SFavouritesInformation
        navigation={this.props.navigation}
        render={args => {
          const { dismissModal } = args;

          return (
            <div style={{ textAlign: 'center' }}>
              <LevelUpText />
              <img
                alt="Favourites info"
                src={require(asset`images/Favourites/Games_Image@3x.png`)}
                style={{ width: '80%', paddingTop: '2%' }}
              />
              <div>
                <p>{CopySelector.getCopy(CopySelector.COPY_TYPES.FAVORITES_REQUIRED_LEVEL)}</p>
              </div>
              <div className="buttonContainer">
                <div className="button" onClick={dismissModal}>
                  <img className="buttonImage" src={require(asset`images/Favourites/OK_Button@3x.png`)} alt="Ok" />
                </div>
              </div>
            </div>
          );
        }}
      />
    );
  }
}

FavouritesInformation.hideOverlay = true;
FavouritesInformation.hideBeforeSelector = true;

